import { hasEmptySurveyPlaceholder } from '@/utils/editor/sanitize-template-variables';
import { useShowToast } from './useShowToast';
import { isEmailBodyEmpty } from '@/utils/emailComposition';

export const useRejection = () => {
  const toast = useShowToast();
  const validateRejectionEmailPayload = (sendRejectEmail, values: any) => {
    const rejectEmailConfig = values?.rejectEmailConfig || {};
    const subject = rejectEmailConfig?.subject || values?.subject;

    if (sendRejectEmail) {
      const from = rejectEmailConfig?.from || values?.from;
      const body = rejectEmailConfig?.body || values?.body;

      if (!from) {
        toast({ title: 'From is mandatory', status: 'error' });
        return false;
      }
      if (!subject) {
        toast({ title: 'Subject is mandatory', status: 'error' });
        return false;
      }
      if (isEmailBodyEmpty(body)) {
        toast({ title: 'Body is mandatory', status: 'error' });
        return false;
      }

      // if survey placeholder is available but no survey is selected
      if (hasEmptySurveyPlaceholder(body)) {
        toast({ title: 'Please select a survey', status: 'error' });
        return false;
      }
    }
    return true;
  };

  return {
    validateRejectionEmailPayload,
  };
};
